import toWebpImage from '@src/utils/to-webp-image';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const pageLocalesData = getPageLocalesData();
const LocalesData = pageLocalesData.mechaUnit;
const welkinData = LocalesData.welkin;
const lang = getLanguageByPath();

/**
 *  特装机甲数据
 */
export const mechaData = {
  mechaName: toWebpImage(`${require('./images/' + lang + '/warrior-name.png')}`),
  mechaImg: toWebpImage(require('./images/structure.png')),
  driverImg: toWebpImage(require('./images/per.png')),
  iconBadge: toWebpImage(require('./images/icon-badge.png')),
  maLogo: toWebpImage(require('./images/ma-logo.png')),
  btnBack: toWebpImage(require('./images/' + lang + '/btn-back.png')),
  driverStoryTitle: require('./images/' + lang + '/driver-story-title.png'),
  cvTab: [toWebpImage(require('./images/checked1.png')), toWebpImage(require('./images/checked2.png')), toWebpImage(require('./images/checked3.png'))],
  audioScreen: require('./images/audio-screen.png'),
  mechaInfoTitle: require('./images/' + lang + '/mecha-info-title.png'),
  manufacturerTitle: require('./images/' + lang + '/manufacturer-title.png'),
  basicInfoTitle: LocalesData.basicInfoTitle,
  driverVoiceTitle: LocalesData.driverVoiceTitle,
  mechaStorySubTitle: LocalesData.mechaStorySubTitle,
  roleExperSubTitle: welkinData.roleExperSubTitle,
  driverName: welkinData.driverName,
  driverType: welkinData.driverType,
  driversSex: welkinData.driversSex,
  driversBirthplace: welkinData.driversBirthplace,
  driversStructure: welkinData.driversStructure,
  driversRoleExperText: welkinData.driversRoleExperText,
  mechaInfoType: welkinData.mechaInfoType,
  mechaInfoNums: welkinData.mechaInfoNums,
  mechaInfoHeadHigh: welkinData.mechaInfoHeadHigh,
  mechaInfoEmptyWeight: welkinData.mechaInfoEmptyWeight,
  mechaInfoTotal: welkinData.mechaInfoTotal,
  mechaInfoStory: welkinData.mechaInfoStory,
  manufacturerGruopCh: welkinData.manufacturerGruopCh,
  cvCH: welkinData.cvCH,
  cvEN: welkinData.cvEN,
  cvJA: welkinData.cvJA,
  zhCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202510/1760148740444_1CN-Vox_Pilot_Get_Elite_RUI.wav',
      title: welkinData.voice.title1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202510/1760148740444_2CN-Vox_Pilot_Entrance_Elite_RUI_a.wav',
      title: welkinData.voice.title2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202510/1760599647237_3CN-Vox_Pilot_MVP_Elite_RUI_c.wav',
      title: welkinData.voice.title3,
      isPlay: false
    }
  ],
  enCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202510/1760148725090_1EN-Vox_Pilot_Get_Elite_RUI.wav',
      title: welkinData.voice.title1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202510/1760148725091_2EN-Vox_Pilot_Entrance_Elite_RUI_a.wav',
      title: welkinData.voice.title2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202510/1760599634489_3EN-Vox_Pilot_MVP_Elite_RUI_c.wav',
      title: welkinData.voice.title3,
      isPlay: false
    }
  ],
  jaCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202510/1760148733783_1JP-Vox_Pilot_Get_Elite_RUI.wav',
      title: welkinData.voice.title1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202510/1760148733783_2JP-Vox_Pilot_Entrance_Elite_RUI_a.wav',
      title: welkinData.voice.title2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202510/1760599641076_3JP-Vox_Pilot_MVP_Elite_RUI_c.wav',
      title: welkinData.voice.title3,
      isPlay: false
    }
  ]
};
